import Decimal from 'decimal.js'
import { Address, FormSubmission } from '@matech/thebigpos-sdk'

export const currencyToFloat = (currency: string) => {
	const numbersOnly = currency.replace(/[^0-9.-]+/g, '')
	return Decimal(numbersOnly)
}

export const percentToDecimal = (percent: number) => {
	if (percent) {
		return Decimal(percent).dividedBy(100)
	}
	return percent
}

export const decimalToPercent = (
	decimal: number,
	suffix: string | null = null
) => {
	if (!decimal) {
		return null
	}

	return Decimal(decimal).times(100).toFixed(2) + (suffix ?? '')
}

export const addressToString = (address: Address) => {
	let addressStr = ''
	if (address.street) {
		addressStr += address.street
		if (address.unit) {
			addressStr += ` ${address.unit}`
		}
	}

	if (address.city) {
		addressStr += ` ${address.city}`
	}

	if (address.state) {
		addressStr += ` ${address.state}`
		if (address.state && address.postalCode) {
			addressStr += ','
		}
	}

	if (address.postalCode) {
		addressStr += ` ${address.postalCode}`
	}

	return addressStr.trim()
}

export const leadAddressToString = (lead: FormSubmission) => {
	const {
		subjectPropertyAddressStreet,
		subjectPropertyAddressCity,
		subjectPropertyAddressState,
		subjectPropertyAddressZip,
	} = lead
	return `${subjectPropertyAddressStreet || ''} ${subjectPropertyAddressCity || ''} ${subjectPropertyAddressState || ''} ${subjectPropertyAddressZip || ''}`
}

export const getLeadBorrowerName = (lead: FormSubmission) => {
	const { firstName, lastName, data } = lead
	if (data && (data.BorrowerFirstName || data.BorrowerLastName)) {
		return `${data.BorrowerFirstName || ''} ${data.BorrowerLastName || ''}`
	}
	return `${firstName || ''} ${lastName || ''}`.trim()
}

export const formatPhoneWithCountryCode = (phone: string) => {
	return `+1${phone.replace(/\D/g, '')}`
}
